import { appStore } from '@/store';
import { pomaLogout } from '@/components/PasswordlessOnboarding/utils';
import { logger, redirectToMerchantOnSuccess } from '@/lib';
import { SPINNER_TYPES } from '@/store/models/constants';

type Options = {
  isPasswordlessFlow: boolean;
  returnToMerchantUrl: string | null | undefined;
};

export const returnToMerchantClickHandler = (
  event: React.MouseEvent,
  options: Options,
): void => {
  event.preventDefault();
  const { isPasswordlessFlow, returnToMerchantUrl } = options;

  returnToMerchant({ isPasswordlessFlow, returnToMerchantUrl });
};

export const returnToMerchant = ({
  isPasswordlessFlow,
  returnToMerchantUrl,
}: Options): Promise<void> => {
  const { ui: uiActions } = appStore.getActions();
  uiActions.setSpinnerType(SPINNER_TYPES.takingYouBack);
  uiActions.toggleIsFormSubmitting(true);

  if (isPasswordlessFlow) {
    return pomaLogout()
      .then(() => {
        // Redirect to merchant page
        logger.info(
          'attempting_redirect_to_merchant_after_poma_logout_in_passkey_page',
          {
            hasReturnUrl: Boolean(returnToMerchantUrl),
          },
        );
        redirectToMerchantOnSuccess(returnToMerchantUrl);
      })
      .catch(({ message, name, stack }) => {
        logger.error(
          'attempting_redirect_to_merchant_passkey_page_poma_logout_failed',
          {
            message,
            name,
            stack,
          },
        );
        redirectToMerchantOnSuccess(returnToMerchantUrl);
      });
  }
  logger.info('attempting_redirect_to_merchant_in_passkey_page', {
    hasReturnUrl: Boolean(returnToMerchantUrl),
  });
  redirectToMerchantOnSuccess(returnToMerchantUrl);
  return Promise.resolve();
};
